import { render, staticRenderFns } from "./liveClassReview.vue?vue&type=template&id=59fa1a72"
import script from "./liveClassReview.vue?vue&type=script&lang=js"
export * from "./liveClassReview.vue?vue&type=script&lang=js"
import style0 from "./liveClassReview.vue?vue&type=style&index=0&id=59fa1a72&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports